import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { array, object, string } from "yup"
import { IPreassignationForm } from "../types"
import { useTranslation } from "react-i18next"

export function usePreassignationForm(
  defaultValues?: Partial<IPreassignationForm>
) {
  const { t } = useTranslation()
  const schema = object({
    events: array()
      .of(string())
      .min(1, t("global.requiredField", { field: t("events.event") })),
  }).required()

  return useForm<IPreassignationForm>({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
